<script setup>

</script>

<template>

  <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_137_11306)">
      <path d="M3.24796 2.32261C3.2021 2.43043 3.17043 2.55052 3.10743 2.64347C2.93127 2.90298 2.74224 3.15208 2.55751 3.40416C2.3675 3.66367 2.35529 3.84585 2.51265 4.12581C2.98603 4.96866 3.59862 5.65462 4.34581 6.18889C4.58101 6.35694 4.7387 6.34764 4.95906 6.14799C5.18536 5.94313 5.41034 5.73604 5.63301 5.52635C5.77387 5.39362 5.92265 5.35496 6.10507 5.40961C6.91956 5.65425 7.5437 6.16547 7.93164 7.02245C8.02203 7.2221 8.0273 7.41023 7.92207 7.59984C7.71029 7.98093 7.50114 8.36425 7.28243 8.74013C7.16532 8.94127 6.99939 9.03311 6.77573 8.98775C5.49479 8.72601 4.35339 8.11143 3.33109 7.22061C1.88389 5.96098 0.814406 4.38309 0.243378 2.40775C0.145733 2.06979 0.0893228 1.71622 0.0157589 1.3697C-0.0300949 1.15481 0.0276347 0.965565 0.184659 0.847706C0.557097 0.567374 0.935144 0.294478 1.32474 0.0453765C1.41776 -0.0141104 1.58237 -0.0137386 1.68233 0.0375688C2.52056 0.465875 2.99559 1.22879 3.21431 2.21516C3.22091 2.24453 3.21893 2.27651 3.22091 2.30737C3.22981 2.31257 3.23872 2.31778 3.24763 2.32261H3.24796Z" fill="#333333"/>
    </g>
    <defs>
      <clipPath id="clip0_137_11306">
        <rect width="8" height="9" fill="white"/>
      </clipPath>
    </defs>
  </svg>



</template>

<style scoped lang="scss">

</style>